/*! Wi-notes - v0.0.1
 * https://www.wicode.pl/
 * Copyright (c) 2017 Wicode; */

var url_notes, url_notes_delete, url_notes_save;
+function ($) {
    'use strict';
    var wiNotes = window.wiNotes;
    window.wiNotes = {
        init: function () {
            wiNotes.events();
        },
        refresh: function () {
        },
        events: function () {
            $(document).on('show.bs.tab', '.tab-notes', function () {
                var ajaxloaded = $(this).attr('data-ajax-loaded');
                if (ajaxloaded === 'false') {
                    $(this).attr('data-ajax-loaded', true);
                    wiVars.set.variable('subreferral_id', 0);
                    wiVars.set.variable('subreferral_type', '');
                    wiVars.set.variables();
                    wiNotes.get.notes();
                }
            });
            $(document).on('click', '.add-note', function (event) {
                event.preventDefault();
                var click = $(this).attr('data-click');
                if (click) {
                    if ($(click).length) {
                        $(click).trigger('click');
                    }
                }
                referral_id = $(this).attr('data-referral-id');
                referral_type = $(this).attr('data-referral-type');
                wiModal.get({
                    modal: 'add_note',
                    module: 'notes',
                    url: 'notes',
                    language_id: language_id,
                    referral_id: referral_id,
                    referral_type: referral_type
                });
            });
            $(document).on('click', '.note-view', function (event) {
                if ($(event.target).closest('.note-actions').length) return;
                event.preventDefault();
                var $inner = $(this);
                var note_id = $inner.find('.edit-note').attr('data-note-id');
                var isPrivate = $inner.closest('.note').hasClass('note-private');
                wiModal.get({
                    modal: 'view_note',
                    module: 'notes',
                    language_id: language_id,
                    referral_id: referral_id,
                    referral_type: referral_type,
                    note_id: note_id,
                    isPrivate: isPrivate
                });
            });
            $(document).on('click', '.edit-note', function (event) {
                event.preventDefault();
                event.stopPropagation();
                referral_id = $(this).attr('data-referral-id');
                referral_type = $(this).attr('data-referral-type');
                var note_id = $(this).attr('data-note-id');
                wiModal.get({
                    modal: 'edit_note',
                    module: 'notes',
                    url: 'notes',
                    language_id: language_id,
                    referral_id: referral_id,
                    referral_type: referral_type,
                    note_id: note_id
                });
            });
            $(document).on('click', '#save_note_btn', function (event) {
                event.preventDefault();
                var form_data = $("#form_note").serialize();
                var btn = $(this);
                var modal = btn.attr('data-modal');
                var icon = btn.find('.fa');
                icon.toggleClass('hidden');
                $.ajax({
                    url: url_notes_save,
                    type: 'POST',
                    data: form_data,
                    success: function (jData) {
                        btn.prop("disabled", false);
                        icon.toggleClass('hidden');
                        if (jData.status === 'success') {
                            wiNotes.get.notes();
                            $(modal).modal('hide');
                        }
                        wiAlerts.add(jData.status, jData.title, jData.msg);
                    }
                });
            });
            $(document).on('click', ".confirm-note-delete", function (event) {
                event.preventDefault();
                event.stopPropagation();
                referral_id = $(this).attr('data-referral-id');
                referral_type = $(this).attr('data-referral-type');
                var note_id = $(this).attr('data-note-id');
                wiModal.get({
                    modal: 'note_delete_confirmation',
                    module: 'notes',
                    url: 'notes',
                    language_id: language_id,
                    referral_id: referral_id,
                    referral_type: referral_type,
                    note_id: note_id
                });
            });
            $(document).on('click', "#note_delete_btn", function (event) {
                event.preventDefault();
                event.stopPropagation();
                var form_data = $("#note_delete_form").serialize();
                $.ajax({
                    url: url_notes_delete,
                    type: 'POST',
                    data: form_data,
                    success: function (jData) {
                        $('#note_delete_confirmation').modal('hide');
                        wiAlerts.add(jData.status, jData.title, jData.msg);
                        wiNotes.get.notes();
                    }
                });
            });
        },
        get: {
            notes: function () {
                $.get(
                        url_notes,
                        {
                            language_id: language_id,
                            referral_id: referral_id,
                            referral_type: referral_type,
                            subreferral_id: subreferral_id,
                            subreferral_type: subreferral_type,
                            csrf_wicode: csrf_value
                        },
                        function (data) {
                            var notes_area = $('#notes_area');
                            notes_area.html(data.notes);
                            setTimeout(function () {
                                notes_area.find('.note-content').each(function () {
                                    if (this.scrollHeight > this.clientHeight) {
                                        $(this).closest('.note-inner').addClass('is-clamped');
                                    }
                                });
                            }, 0);
                        }
                );
            }
        }
    };
    $(function () {
        url_notes = urls.notes + '/get_notes';
        url_notes_save = urls.notes + '/save_note';
        url_notes_delete = urls.notes + '/delete_note';

        wiNotes = window.wiNotes;
        wiNotes.init();
    });
}(jQuery);
